import React from 'react';
import {useTheme} from '../theme';

export default function BrandSignet({base=''}) {
  const {theme,lightAvailable}=useTheme();
  const daylight=lightAvailable && theme==='light';
 return <img src={base+(daylight ? '/brand/ea-signet-daylight-v1.webp' : '/brand/ea-signet.webp')} alt=""/>;
}
